export default [
    {
        path: "/reverse-auction/auction-bid",
        name: "auction-bid",
        meta: {title: "Live Auction Bidding", authRequired: true, privileges: ['SUPPLIER_PARTICIPATE_REVERSE_AUCTIONS']},
        component: () => import("../views/reverse-auction/auction-bid.vue"),
    },

    {
        path: "/reverse-auction/upcoming-auctions",
        name: "upcoming-auctions",
        meta: {title: "Upcoming Auctions", authRequired: true, privileges: ['SUPPLIER_VIEW_REVERSE_AUCTIONS']},
        component: () => import("../views/reverse-auction/upcoming-auctions.vue"),
    },

    {
        path: "/reverse-auction/scheduled-auctions",
        name: "scheduled-auctions",
        meta: {title: "Scheduled Auctions", authRequired: true, privileges: ['SUPPLIER_VIEW_REVERSE_AUCTIONS']},
        component: () => import("../views/reverse-auction/scheduled-auctions.vue"),
    },

    {
        path: "/reverse-auction/live-auctions",
        name: "live-auctions",
        meta: {title: "Live Auctions", authRequired: true, privileges: ['SUPPLIER_VIEW_REVERSE_AUCTIONS', 'SUPPLIER_PARTICIPATE_REVERSE_AUCTIONS']},
        component: () => import("../views/reverse-auction/live-auctions.vue"),
    },

]
